import { EXECUTE_SQL_MAX_LIMIT } from "./tablePaginationUtils";

function readPositiveInt(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
}

/**
 * Max rows for optional "Rows to display" in sort (capped by query total and API max).
 */
export function resolveSortRowCount({ queryRowCount, loadedCount } = {}) {
  const total =
    readPositiveInt(queryRowCount) ?? readPositiveInt(loadedCount) ?? null;
  if (total == null) return EXECUTE_SQL_MAX_LIMIT;
  return Math.min(total, EXECUTE_SQL_MAX_LIMIT);
}

/** Full result size from the query (for display), when known. */
export function resolveQueryTotalRowCount({ queryRowCount, loadedCount } = {}) {
  return readPositiveInt(queryRowCount) ?? readPositiveInt(loadedCount) ?? null;
}
